import { useTranslation } from 'react-i18next'
import Section from '../../components/Dashboard/Section'
import PaymentHistorySection from '../../components/Dashboard/Subscription/PaymentHistorySection'
import SubscriptionPlanSection from '../../components/Dashboard/Subscription/SubscriptionPlanSection'
import CreditPackSection from '../../components/Dashboard/Subscription/CreditPackSection'
import PaymentInfoSection from '../../components/Dashboard/Subscription/PaymentInfoSection'
import { useCurrentWorkspaceDetailQuery } from '../../hooks/queries'
import { CreditPackPausedNotice } from '../../components/Dashboard/Subscription/CreditPackTerminationNotice'

export default function Subscription() {
  const { data: workspace } = useCurrentWorkspaceDetailQuery()
  const { paymentMethod, isManualPayment } = workspace?.subscription ?? {}
  const { t } = useTranslation('subscription')

  return (
    <Section
      className="mt-[40px]"
      title={t('구독 관리')}
      description={t('구독 중인 플랜과 결제 정보를 확인할 수 있습니다.')}
    >
      <div className="mt-[55px] flex flex-wrap items-stretch gap-[16px]">
        <SubscriptionPlanSection />
        <CreditPackSection />
      </div>
      {/* P6 · 구독 종료 후(비활성) 크레딧 팩 잔액 안내. 구독 종료일은 잔액 응답의 terminatedOn(startedAt 은 BE 배포 전 대체값) */}
      {workspace?.subscription?.status === 'PAUSE' && workspace.subscription.startedAt ? (
        <CreditPackPausedNotice
          className="mt-[16px]"
          workspaceId={workspace.id}
          subscriptionStartedAt={workspace.subscription.startedAt}
        />
      ) : null}
      {paymentMethod || workspace?.subscription?.isManualPayment ? (
        <PaymentInfoSection className="mt-[16px]" isManualPayment={isManualPayment} />
      ) : null}
      {paymentMethod ? <PaymentHistorySection className="mt-[39px]" /> : null}
    </Section>
  )
}
